import { useState } from "react";
import { Flower2 } from "lucide-react";
import { CostTable, RightsList, HelpList, LinksList, QuotesTable } from "./FuneralResources";
import { tr } from "../../lib/i18n";

const TABS = [["costs", "Typical costs"], ["rights", "Your rights"], ["help", "Help paying"], ["docs", "Where to get documents"], ["quotes", "Quotes"]];

// Read-only funeral resources inside the shared (code-protected) bereavement pack.
export const SharedFuneralResources = ({ f }) => {
  const [tab, setTab] = useState("costs");
  const tabs = TABS.filter(([v]) => v !== "quotes" || f.quotes?.length);
  return (
    <div className="rounded-2xl border border-border bg-card p-5" data-testid="share-funeral-resources">
      <div className="flex items-center gap-2"><Flower2 className="h-4 w-4 text-primary" /><h2 className="font-serif text-lg">Funeral costs & help</h2></div>
      <div className="flex flex-wrap gap-1.5 mt-3">{tabs.map(([v, l]) => <button key={v} data-testid={`share-funeral-tab-${v}`} onClick={() => setTab(v)} className={`text-xs rounded-full border px-3 py-1.5 ${tab === v ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>{tr(l)}</button>)}</div>
      <div className="mt-4">
        {tab === "costs" && <CostTable costs={f.costs} addOns={f.add_ons} sources={f.sources} note="US national medians (NFDA 2023); every funeral home must give you an itemized price list on request." />}
        {tab === "rights" && <RightsList rights={f.rights} />}
        {tab === "help" && <HelpList help={f.help} />}
        {tab === "docs" && <LinksList links={f.links} />}
        {tab === "quotes" && <QuotesTable quotes={f.quotes} quoteItems={f.quote_items} />}
      </div>
    </div>
  );
};
